import { render, staticRenderFns } from "./clinicasInactivas.vue?vue&type=template&id=191bf04d"
import script from "./clinicasInactivas.vue?vue&type=script&lang=js"
export * from "./clinicasInactivas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports